export const EVENT_OPERATION_UPDATE = 'operation.update'
